import { ref } from "vue"
import { defineStore } from "pinia"
import { api } from "@/lib/api"
import type { PublicConfig, PublicModel } from "@/types/api"

export const usePublicStore = defineStore("public", () => {
  const config = ref<PublicConfig | null>(null)
  const models = ref<PublicModel[]>([])
  const loading = ref(false)
  let request: Promise<void> | null = null

  function load(force = false): Promise<void> {
    if (request && !force) return request
    if (config.value && !force) return Promise.resolve()
    loading.value = true
    request = Promise.all([api.public.config(), api.public.models()])
      .then(([nextConfig, nextModels]) => {
        config.value = nextConfig
        models.value = nextModels
      })
      .finally(() => {
        loading.value = false
        request = null
      })
    return request
  }

  return { config, models, loading, load }
})
